<div
  class="transaction-item-wrapper p-relative"
  (click)="selectAccountTransactionDetails()"
  [routerLink]="[
    '/accounts',
    {
      outlets: {
        sidebar: ['transaction-details', transactionData?.transactionId]
      }
    }
  ]"
  routerLinkActive="active-details"
>
  <div fxLayoutAlign="start center">
    <div
      class="img-wrapper mr-25"
      [ngClass]="
        transactionData?.status === transactionStatus.Rejected
          ? 'img-wrapper--gray'
          : ''
      "
      fxLayoutAlign="center center"
    >
      <img *ngIf="addImageToTransaction(transactionData)" [src]="addImageToTransaction(transactionData)" alt="icon" />
    </div>
    <div>
      <p
        [ngClass]="
          transactionData?.status === transactionStatus.Rejected
            ? 'text-gray'
            : 'text-black'
        "
      >
        {{ transactionData?.payerPayee }}
      </p>
      <p class="font-13 text-gray">{{ transactionData?.description }}</p>
    </div>
  </div>
  <div
    [ngClass]="
      transactionData?.status === transactionStatus.Rejected
        ? 'transaction-rejected'
        : ''
    "
    fxLayoutAlign="end center"
  >
    <span
      *ngIf="checkIfTransactionIsPositive(transactionData)"
      class="positive-price font-bold"
      >+</span
    >
    <span
      *ngIf="!checkIfTransactionIsPositive(transactionData)"
      class="negative-price font-bold"
      >-</span
    >
    <span
      class="font-bold mr-5"
      [ngClass]="
        checkIfTransactionIsPositive(transactionData)
          ? 'positive-price'
          : 'negative-price'
      "
      [lnsAccountBalance]="transactionData?.paymentAmount"
    ></span>
    <span
      [ngClass]="
        checkIfTransactionIsPositive(transactionData)
          ? 'positive-price'
          : 'negative-price'
      "
    >
      {{ transactionData?.paymentCurrency }}
    </span>
  </div>
</div>
